module.exports = __webpack_public_path__ + "static/media/upgrade_icon.16f40f6e.svg";